module.exports = __webpack_public_path__ + "alignment-good.537b59c454a5db72bed208b9cd96162f.hashedasset.png";